/**
 * Query keys for inbound routing. Lives with the other key factories so a hook
 * outside the routing feature (project lifecycle, project settings) can
 * invalidate routing caches without importing the feature's hooks module.
 */
export const inboundRoutingKeys = {
  /** Every org's routing cache — for callers that have no org context. */
  root: ['inbound-routing'] as const,
  all: (selectedOrgId: string | null) =>
    [...inboundRoutingKeys.root, selectedOrgId] as const,
  lists: (selectedOrgId: string | null) =>
    [...inboundRoutingKeys.all(selectedOrgId), 'list'] as const,
  list: (selectedOrgId: string | null, filters: { projectId?: string }) =>
    [...inboundRoutingKeys.lists(selectedOrgId), filters] as const,
  details: (selectedOrgId: string | null) =>
    [...inboundRoutingKeys.all(selectedOrgId), 'detail'] as const,
  detail: (selectedOrgId: string | null, id: string) =>
    [...inboundRoutingKeys.details(selectedOrgId), id] as const,
  fallback: (selectedOrgId: string | null) =>
    [...inboundRoutingKeys.all(selectedOrgId), 'fallback'] as const,
};
